/** Community Tagging w. Autocomplete **/
import Tagify from '@yaireo/tagify'

// tagList is defined in the template's js block
tagList.push('Sound')
tagList.push('Silent')
tagList.push('Oral History')

let cleanTags = [...new Set(tagList)]

cleanTags = JSON.stringify(cleanTags)
cleanTags = cleanTags.split('&Amp;').join('&')
cleanTags = JSON.parse(cleanTags)

var input = document.querySelector('textarea[name="tagstring"]'),
    tagify = new Tagify(input, {
        whitelist: cleanTags,
        placeholder: 'Type a word or phrase, separating entries with a comma.',
        dropdown: {
            classname: 'tags',
            enabled: 2, // show the dropdown immediately on focus
            maxItems: 6, // maximum suggested items
            position: 'text', // place the dropdown near the typed text
            closeOnSelect: true, // close the dropdown open after selecting a suggestion
            highlightFirst: false,
            sortby: 'startsWith',
        },
    })
